import React, { useState } from 'react'

function First() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    dailyConsumption: '',
    nightlyConsumption: '',
    batteryHours: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // هنا يمكن إرسال البيانات للباك إند
    console.log('Form Data:', formData);
    // TODO: إرسال البيانات للباك إند عبر API
  };

  return (
    <>
        <section id="contact" className="contact-area after-none contact-bg pt-120 pb-120 p-relative fix" >
            <div className="container">
                <div className="row">
                <div className="col-lg-5">
                    <div className="contact-info"
                    style={{ background: "url(assets/img/bg/footer-bg.png) no-repeat", backgroundSize: "cover" }} >
                    <div className="single-cta pb-30 mb-30 wow fadeInUp animated" data-animation="fadeInDown animated" data-delay=".2s" >
                        <div className="f-cta-icon">
                        <i className="far fa-map" />
                        </div>
                        <h5>Office Address</h5>
                        <p>
                        380 St Kilda Road, Melbourne <br />
                        VIC 3004, Australia
                        </p>
                    </div>
                    <div className="single-cta pb-30 mb-30 wow fadeInUp animated"
                        data-animation="fadeInDown animated" data-delay=".2s" >
                        <div className="f-cta-icon">
                        <i className="far fa-clock" />
                        </div>
                        <h5>Working Hours</h5>
                        <p>
                        Monday to Friday 09:00 to 18:30 and <br />
                        Saturday we work until 15:30
                        </p>
                    </div>
                    <div className="single-cta pb-30 mb-30 wow fadeInUp animated" data-animation="fadeInDown animated"
                        data-delay=".2s" >
                        <div className="f-cta-icon">
                        <i className="far fa-envelope-open" />
                        </div>
                        <h5>Message Us</h5>
                        <p>
                        We are always with you to solve your problem mail us :{" "}
                        <a href="#">support@example.com</a>
                        </p>
                    </div>
                    </div>
                </div>
                <div className="col-lg-7">
                    <div className="contact-bg02 wow fadeInLeft  animated">
                    <div className="section-title center-align">
                        <h5>CONTACT US</h5>
                        <h2>Get A Quote</h2>
                    </div>
                    <form onSubmit={handleSubmit} className="contact-form mt-30">
                        <div className="row">
                        {/* المعلومات الشخصية */}
                        <div className="col-lg-12">
                            <h4 className="mb-20" style={{ color: '#7dc520', borderBottom: '2px solid #7dc520', paddingBottom: '10px' }}>المعلومات الشخصية</h4>
                        </div>
                        <div className="col-lg-6">
                            <div className="contact-field p-relative c-name mb-30">
                            <input 
                                type="text" 
                                id="firstn" 
                                name="firstName" 
                                placeholder="First Name" 
                                value={formData.firstName}
                                onChange={handleChange}
                                required 
                            />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="contact-field p-relative c-email mb-20">
                            <input 
                                type="text" 
                                id="lastn" 
                                name="lastName" 
                                placeholder="Last Name" 
                                value={formData.lastName}
                                onChange={handleChange}
                                required 
                            />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="contact-field p-relative c-subject mb-30">
                            <input 
                                type="email" 
                                id="email" 
                                name="email" 
                                placeholder="Email" 
                                value={formData.email}
                                onChange={handleChange}
                                required 
                            />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="contact-field p-relative c-subject mb-30">
                            <input 
                                type="text" 
                                id="phone" 
                                name="phone" 
                                placeholder="Phone No." 
                                value={formData.phone}
                                onChange={handleChange}
                                required 
                            />
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="contact-field p-relative c-subject mb-30">
                            <input 
                                type="text" 
                                id="subject" 
                                name="subject" 
                                placeholder="Subject" 
                                value={formData.subject}
                                onChange={handleChange}
                                required 
                            />
                            </div>
                        </div>

                        {/* معلومات الاستهلاك */}
                        <div className="col-lg-12">
                            <h4 className="mb-20 mt-30" style={{ color: '#7dc520', borderBottom: '2px solid #7dc520', paddingBottom: '10px' }}>معلومات الاستهلاك</h4>
                        </div>
                        <div className="col-lg-6">
                            <div className="contact-field p-relative c-subject mb-30">
                            <input 
                                type="number" 
                                id="dailyConsumption" 
                                name="dailyConsumption" 
                                placeholder="كمية الاستهلاك النهاري بالأمبير" 
                                value={formData.dailyConsumption}
                                onChange={handleChange}
                                step="0.01"
                                min="0"
                                required 
                            />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="contact-field p-relative c-subject mb-30">
                            <input 
                                type="number" 
                                id="nightlyConsumption" 
                                name="nightlyConsumption" 
                                placeholder="كمية الاستهلاك الليلي بالأمبير في الساعة الواحدة" 
                                value={formData.nightlyConsumption}
                                onChange={handleChange}
                                step="0.01"
                                min="0"
                                required 
                            />
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="contact-field p-relative c-subject mb-30">
                            <input 
                                type="number" 
                                id="batteryHours" 
                                name="batteryHours" 
                                placeholder="عدد الساعات الاستفادة من البطارية ليلاً" 
                                value={formData.batteryHours}
                                onChange={handleChange}
                                step="0.5"
                                min="0"
                                required 
                            />
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="contact-field p-relative c-message mb-30">
                            <textarea 
                                name="message" 
                                id="message" 
                                cols={30} 
                                rows={10} 
                                placeholder="Write comments" 
                                value={formData.message}
                                onChange={handleChange}
                            />
                            </div>
                            <div className="slider-btn">
                            <button type="submit" className="btn ss-btn" data-animation="fadeInRight" data-delay=".8s" >
                                Submit Now
                            </button>
                            </div>
                        </div>
                        </div>
                    </form>
                    </div>
                </div>
                </div>
            </div>
        </section>

        <div className="map fix">
            <div className="container-flud">
                <div className="row">
                <div className="col-lg-12">
                    <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d212867.83634504632!2d-112.24455686962897!3d33.52582710700138!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x872b743829374b03%3A0xabaac255b1e43fbe!2sPlexus%20Worldwide!5e0!3m2!1sen!2sin!4v1618567685329!5m2!1sen!2sin"
                    width={600}
                    height={450}
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    />
                </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default First